import React from 'react';
import { useIntl } from 'react-intl';

import Message, { MessageProps } from 'carbon-react/lib/components/message';
import Typography from 'carbon-react/lib/components/typography';

import { WizardFormErrors } from '../types';

import styles from './wizard-form-validation-error-summary.scss';

export interface WizardFormValidationErrorSummaryProps extends Omit<MessageProps, 'variant' | 'title'> {
  errors?: WizardFormErrors;
}
export const WizardFormValidationErrorSummary = ({ errors = {}, ...props }: WizardFormValidationErrorSummaryProps) => {
  const intl = useIntl();

  if (Object.keys(errors).length === 0) {
    return null;
  }

  return (
    <Message
      {...props}
      variant="error"
      title={intl.formatMessage({
        id: 'common.there_is_a_problem',
        defaultMessage: 'There is a problem'
      })}
    >
      <ul className={styles.errorList}>
        {Object.values(errors).map(error => (
          <li key={error.id}>
            <Typography variant="p" m={0}>
              <a className={styles.errorLink} href={`#${error.id}`}>
                {error.message}
              </a>
            </Typography>
          </li>
        ))}
      </ul>
    </Message>
  );
};
